import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { UserService } from '@services/user.service';

@Component({
  selector: 'app-unsubscribe-newsletter',
  templateUrl: './unsubscribe-newsletter.component.html',
  styleUrls: ['./unsubscribe-newsletter.component.scss']
})
export class UnsubscribeNewsletterComponent implements OnInit {

    isLoaded: boolean = false;

    constructor(
        private route: ActivatedRoute,
        private userSrv: UserService
    ) {}

    ngOnInit(): void {
        this.route.queryParams.subscribe(params => {
            this.userSrv.unsubscribeNewsletter(params.token).subscribe(_ => this.isLoaded = true);
        });
    }
}
